// @ts-strict-ignore
import { getProductTableWithRelations } from '../../utils/contentful'
import getWindow from '../../utils/get-window'
import { getTrackingSchema } from '../../utils/segment-tracking'
import { FsCore } from '../../types/fs-core'
import { getSorts, getMaxPerPage } from '../../redux/product-tables/product-table-selectors'
import { getFilterGroup } from '../../redux/filters/filters-selectors'
import { getCalculator } from '../../redux/calculators/calculators-selectors'
const fetchOrAxios = async ({ url, method, headers, data }) => {
  if (getWindow().axios) {
    return getWindow()
      .axios({
        method,
        url,
        headers,
        data,
      })
      .then((data) => data.data)
  }
  return fetch(url, { method, headers, body: JSON.stringify(data) }).then((data) => data.json())
}

export type FetchDataOptions = {
  state: FsCore.State
  newSort?: FsCore.SortState | undefined
  newFilters?: FsCore.FilterGroupState | undefined
  newCalculator?: FsCore.CalculatorState | undefined
  calculatorId?: string | undefined
  filtersId?: string | undefined
  pageOffset?: number | undefined
  productTableId?: string | undefined
  overrideQueryId?: string | undefined
  maxPerPage?: number | undefined
  scoredEligibilityIds?: any | undefined
  noEligibilityResults?: boolean | undefined
}
export default async ({
  state,
  newSort,
  newFilters,
  newCalculator,
  calculatorId,
  filtersId,
  pageOffset = 0,
  productTableId,
  overrideQueryId,
  maxPerPage,
  scoredEligibilityIds,
  noEligibilityResults,
}: FetchDataOptions) => {
  const { productTable, productTableSchema, productDataset } = getProductTableWithRelations(
    state,
    productTableId!,
  )

  let queryId = productDataset?.sys?.id!

  const schema = productTableSchema?.fields?.schema!
  const sorts = getSorts(state, queryId)
  queryId = overrideQueryId || queryId
  // We are sending the tracking schema to the server so it knows to keep important segment fields in the data
  const trackingSchema = getTrackingSchema(state, productTable!.fields)

  const currentCalculator = calculatorId ? getCalculator(state, calculatorId!) : undefined
  const currentFilters = getFilterGroup(state, filtersId!)

  const data = await fetchOrAxios({
    url: `/elastic/data`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
    data: {
      trackingSchema,
      schema,
      queryId,
      pageOffset,
      maxPerPage: maxPerPage || getMaxPerPage(state, queryId),
      sorts: {
        ...sorts,
        selectedSort: newSort || sorts.selectedSort,
      },
      filters: getFilters({
        currentCalculator,
        currentFilters,
        newFilters,
        newCalculator,
      }),
      scoredEligibilityIds,
      noEligibilityResults,
    },
  })
  return data
}

export type GetFiltersOptions = {
  currentCalculator?: FsCore.CalculatorState
  currentFilters?: FsCore.FilterGroupState
  newFilters?: FsCore.FilterGroupState
  newCalculator?: FsCore.CalculatorState
}
const getFilters = ({
  currentCalculator,
  currentFilters,
  newFilters,
  newCalculator,
}: GetFiltersOptions) => {
  if (newFilters && currentCalculator) {
    return [currentCalculator, ...newFilters.filters]
  } else if (newFilters) {
    return newFilters.filters
  } else if (newCalculator) {
    return [newCalculator, ...(currentFilters?.filters || [])]
  } else if (currentCalculator) {
    return [currentCalculator, ...(currentFilters?.filters || [])]
  } else {
    return currentFilters?.filters || []
  }
}
